import { render, staticRenderFns } from "./Page1.vue?vue&type=template&id=fbcb09dc&scoped=true&"
import script from "./Page1.vue?vue&type=script&lang=ts&"
export * from "./Page1.vue?vue&type=script&lang=ts&"
import style0 from "./Page1.vue?vue&type=style&index=0&id=fbcb09dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcb09dc",
  null
  
)

export default component.exports